// hooks/usePlanType.js
import get from "lodash/get";
import { PLAN_TYPE } from "../constants/AppConstants";
import isEmpty from "lodash/isEmpty";

export const usePlanType = () => {
  const merchant = JSON.parse(sessionStorage.getItem("storeDetails"));
  const planType = get(merchant, "data.recentSubscription.planType");
  const subscriptionStatus = get(merchant, "data.dataValues.status");
  const isLitePlan = planType === PLAN_TYPE.LITE;

  const isProPlan = planType === PLAN_TYPE.PRO;
  const isUltraPlan = !isLitePlan && !isProPlan;
  const isPaidAccount = !isEmpty(subscriptionStatus)
    ? subscriptionStatus === "PAID"
    : true;
  return {
    planType,
    isLitePlan,
    isProPlan,
    isUltraPlan,
    isPaidAccount,
  };
};
